export default {
  anomalyChart: {
    MIN_BAR_WIDTH: 18, //px
    MARGIN_TOP: 30, //px
    MARGIN_BOTTOM: 30, //px
    MARGINS: {
      marginOuter: 1,
      marginInner: 1,
    },
    CHART_CONFIG: [
      {
        barNumber: 5,
        bar: 1,
        paddingBar: 0.25,
      },
      {
        barNumber: 12,
        bar: 1,
        paddingBar: 0.25,
      },
      {
        barNumber: 4,
        bar: 1,
        paddingBar: 0.25,
      },
    ],
    CHART_TYPE: {
      WEEK: {
        index: 0,
      },
      MONTH: {
        index: 1,
      },
      TRIMESTER: {
        index: 2,
      },
    },
  },

  defaultCode: 'VNINDEX',
  average: 'Average',
  yearAverageFromServer: 0,

  typeFilterYear: {
    ALL_TIME: 'all',
    RECENT_YEARS_5: 5,
    RECENT_YEARS_10: 10,
  },

  listKeyFilterYear: ['FiveYears', 'TenYears', 'AllTime'],
  listFilterYearByKey: {
    AllTime: { key: 'AllTime', title: 'marketInDepthAnomaly.allTime' },
    FiveYears: { key: 'FiveYears', title: 'marketInDepthAnomaly.recentYear5' },
    TenYears: { key: 'TenYears', title: 'marketInDepthAnomaly.recentYear10' },
  },

  listKeyFilterDateTime: ['day', 'month', 'quarter'],
  listFilterDateTimeByKey: {
    day: { key: 'day' },
    month: { key: 'month' },
    quarter: { key: 'quarter' },
  },

  listColumn: {
    YEAR: 'year',
    MONDAY: 'mon',
    TUESDAY: 'tue',
    WEDNESDAY: 'wed',
    THURSDAY: 'thu',
    FRIDAY: 'fri',
    JANUARY: 'jan',
    FEBRUARY: 'feb',
    MARCH: 'mar',
    APRIL: 'apr',
    MAY: 'may',
    JUNE: 'jun',
    JULY: 'jul',
    AUGUST: 'aug',
    SEPTEMBER: 'sep',
    OCTOBER: 'oct',
    NOVEMBER: 'nov',
    DECEMBER: 'dec',
    QUARTER_ONE: 'i',
    QUARTER_TWO: 'ii',
    QUARTER_THREE: 'iii',
    QUARTER_FOUR: 'iv',
  },

  listHideColumnWeekTable: [
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dec',
    'i',
    'ii',
    'iii',
    'iv',
  ],

  listHideColumnMonthTable: [
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'i',
    'ii',
    'iii',
    'iv',
  ],

  listHideColumnQuarterTable: [
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dec',
  ],

  indexData: {
    VALUE: 'value',
    VALUE_CHANGE: 'valueChange',
    PERCENT_VALUE_CHANGE: 'percentValueChange',
  },

  dataWeek: [
    { time_text: 'M', time_tooltip: 'monday', time: 0, key: 'mon' },
    { time_text: 'T', time_tooltip: 'tuesday', time: 1, key: 'tue' },
    { time_text: 'W', time_tooltip: 'wednesday', time: 2, key: 'wed' },
    { time_text: 'T', time_tooltip: 'thursday', time: 3, key: 'thu' },
    { time_text: 'F', time_tooltip: 'friday', time: 4, key: 'fri' },
  ],
  dataMonth: [
    { time_text: 'JAN', time_tooltip: 'january', time: 0, key: 'jan' },
    { time_text: 'FEB', time_tooltip: 'february', time: 1, key: 'feb' },
    { time_text: 'MAR', time_tooltip: 'march', time: 2, key: 'mar' },
    { time_text: 'APR', time_tooltip: 'april', time: 3, key: 'apr' },
    { time_text: 'MAY', time_tooltip: 'may', time: 4, key: 'may' },
    { time_text: 'JUN', time_tooltip: 'june', time: 5, key: 'jun' },
    { time_text: 'JUL', time_tooltip: 'july', time: 6, key: 'jul' },
    { time_text: 'AUG', time_tooltip: 'august', time: 7, key: 'aug' },
    { time_text: 'SEP', time_tooltip: 'september', time: 8, key: 'sep' },
    { time_text: 'OCT', time_tooltip: 'october', time: 9, key: 'oct' },
    { time_text: 'NOV', time_tooltip: 'november', time: 10, key: 'nov' },
    { time_text: 'DEC', time_tooltip: 'december', time: 11, key: 'dec' },
  ],
  dataTrimester: [
    { time_text: 'Q1', time_tooltip: 'quarter1', time: 0, key: 'i' },
    { time_text: 'Q2', time_tooltip: 'quarter2', time: 1, key: 'ii' },
    { time_text: 'Q3', time_tooltip: 'quarter3', time: 2, key: 'iii' },
    { time_text: 'Q4', time_tooltip: 'quarter4', time: 3, key: 'iv' },
  ],

  dataWeekVi: [
    { time_text: 'T2', time_tooltip: 'Thứ 2', time: 0, key: 'mon' },
    { time_text: 'T3', time_tooltip: 'Thứ 3', time: 1, key: 'tue' },
    { time_text: 'T4', time_tooltip: 'Thứ 4', time: 2, key: 'wed' },
    { time_text: 'T5', time_tooltip: 'Thứ 5', time: 3, key: 'thu' },
    { time_text: 'T6', time_tooltip: 'Thứ 6', time: 4, key: 'fri' },
  ],
  dataMonthVi: [
    { time_text: 'T1', time_tooltip: 'Tháng 1', time: 0, key: 'jan' },
    { time_text: 'T2', time_tooltip: 'Tháng 2', time: 1, key: 'feb' },
    { time_text: 'T3', time_tooltip: 'Tháng 3', time: 2, key: 'mar' },
    { time_text: 'T4', time_tooltip: 'Tháng 4', time: 3, key: 'apr' },
    { time_text: 'T5', time_tooltip: 'Tháng 5', time: 4, key: 'may' },
    { time_text: 'T6', time_tooltip: 'Tháng 6', time: 5, key: 'jun' },
    { time_text: 'T7', time_tooltip: 'Tháng 7', time: 6, key: 'jul' },
    { time_text: 'T8', time_tooltip: 'Tháng 8', time: 7, key: 'aug' },
    { time_text: 'T9', time_tooltip: 'Tháng 9', time: 8, key: 'sep' },
    { time_text: 'T10', time_tooltip: 'Tháng 10', time: 9, key: 'oct' },
    { time_text: 'T11', time_tooltip: 'Tháng 11', time: 10, key: 'nov' },
    { time_text: 'T12', time_tooltip: 'Tháng 12', time: 11, key: 'dec' },
  ],
  dataTrimesterVi: [
    { time_text: 'Q1', time_tooltip: 'Quý 1', time: 0, key: 'i' },
    { time_text: 'Q2', time_tooltip: 'Quý 2', time: 1, key: 'ii' },
    { time_text: 'Q3', time_tooltip: 'Quý 3', time: 2, key: 'iii' },
    { time_text: 'Q4', time_tooltip: 'Quý 4', time: 3, key: 'iv' },
  ],

  listTicker: {
    ORGAN_CODE: 'organCode',
    TICKER: 'ticker',
    ORGAN_SHORT_NAME: 'organShortName',
    COM_GROUP_CODE: 'comGroupCode',
  },

  listIndex: {
    COM_GROUP_CODE: 'comGroupCode',
    COM_GROUP_NAME: 'comGroupName',
    PARENT_COM_GROUP_CODE: 'parentComGroupCode',
  },

  listIndexName: {
    vnIndex: 'VNINDEX',
    hnIndex: 'HNXIndex',
    upcomIndex: 'UpcomIndex',
  },

  listIndexExchange: {
    hose: 'HOSE',
    hnx: 'HNX',
    upcom: 'UPCOM',
  },
};
